import { render, staticRenderFns } from "./ProductPicker.vue?vue&type=template&id=2dca71d2&scoped=true&"
import script from "./ProductPicker.vue?vue&type=script&lang=ts&"
export * from "./ProductPicker.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPicker.vue?vue&type=style&index=0&id=2dca71d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dca71d2",
  null
  
)

export default component.exports